import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/global.css';
import './styles/tokens-noir.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Service worker registration — DISABLED.
//
// We previously registered a cache-first PWA worker that left users stuck on
// stale builds after every redeploy. /public/sw.js has been replaced by a
// kill-switch that auto-cleans existing installs. We do NOT register it here
// any more — new visitors get a normal browser-cached SPA, which always
// reflects the latest deploy. If we want PWA features back later, switch to
// a network-first Workbox setup.
//
// Defensive cleanup: if a stale SW from a previous build is still controlling
// this tab (shouldn't happen after the kill-switch ships, but belt-and-braces
// for the rollout window), proactively unregister anything we find.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(regs => { for (const r of regs) r.unregister().catch(() => {}); })
    .catch(() => {});
}
